export default "__VITE_ASSET__DFCe_9$5__"